import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { FzunterklasseListView } from './list-view/fzunterklasse.list-view';

export const fzunterklasseFieldOk: FieldOkConfig = {
  name: 'fzunterklasse',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{fzunterklasse}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzunterklasseListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
export const fzunterklasseMultiselectFieldOk: FieldOkConfig = {
  name: 'fzunterklasse',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{fzunterklasse}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzunterklasseListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};

export const fzunterklasseQueryFieldOk: FieldOkConfig = {
  name: 'fzunterklasse',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{fzunterklasse}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzunterklasseListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
